export default __webpack_public_path__ + "static/du-logo@2x-263502640207cd5a1d2005aff79fddc7.png";